/* Farmacia Leira — movimiento de la página "Sobre nosotros".
   Revela los bloques al entrar en pantalla y anima los contadores de cifras.
   Si no hay JavaScript o el usuario pide menos movimiento, el CSS deja todo
   visible: esto solo añade el efecto, nunca esconde contenido de forma
   permanente. */
(() => {
  const menosMovimiento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const bloques = document.querySelectorAll('[data-fl-anim]');
  if (bloques.length === 0) return;

  /* La banda a sangre mide 100vw, que en Windows incluye el ancho de la barra
     de desplazamiento. Guardamos ese sobrante para descontarlo en el CSS. */
  const medirBarra = () => {
    const barra = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--fl-barra', `${Math.max(barra, 0)}px`);
  };
  medirBarra();
  window.addEventListener('resize', medirBarra);

  /* --- Contadores --------------------------------------------------------- */
  /* Intl con es-ES no agrupa los números de cuatro cifras (1600 → "1600"),
     así que ponemos el punto de los millares a mano. */
  const formato = {
    format: (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
  };

  function animarContador(el) {
    const destino = Number(el.dataset.flContador);
    if (!Number.isFinite(destino)) return;

    const prefijo = el.dataset.flPrefijo || '';
    const sufijo = el.dataset.flSufijo || '';
    const pintar = (v) => {
      el.textContent = prefijo + formato.format(v) + sufijo;
    };

    /* Con la pestaña en segundo plano el navegador congela requestAnimationFrame
       y el número se quedaría clavado en 0: en ese caso lo pintamos ya. */
    if (menosMovimiento || document.visibilityState !== 'visible') {
      pintar(destino);
      return;
    }

    const duracion = 1100;
    let inicio = null;

    const paso = (ahora) => {
      if (inicio === null) inicio = ahora;
      const avance = Math.min((ahora - inicio) / duracion, 1);
      // easeOutCubic
      const suave = 1 - Math.pow(1 - avance, 3);
      pintar(Math.round(destino * suave));
      if (avance < 1) requestAnimationFrame(paso);
    };

    pintar(0);
    requestAnimationFrame(paso);
  }

  /* --- Revelado ----------------------------------------------------------- */
  function revelar(bloque) {
    bloque.classList.add('es-visible');
    bloque.querySelectorAll('[data-fl-contador]').forEach(animarContador);
  }

  if (menosMovimiento || !('IntersectionObserver' in window)) {
    bloques.forEach(revelar);
    return;
  }

  document.documentElement.classList.add('fl-anim-lista');

  const observador = new IntersectionObserver(
    (entradas) => {
      entradas.forEach((entrada) => {
        if (!entrada.isIntersecting) return;
        revelar(entrada.target);
        observador.unobserve(entrada.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
  );

  bloques.forEach((bloque) => observador.observe(bloque));

  /* Red de seguridad: si algo fallara, a los 4 s todo queda visible. */
  window.setTimeout(() => bloques.forEach(revelar), 4000);
})();
